import React, { useEffect, useState } from 'react'
import StepWizard from 'react-step-wizard'
import GeneralData from './GeneralData'
import LocationData from './LocationData'
import EvaluationData from './EvaluationData'
import './crearFormulario.scss'
import { Grid, CircularProgress, Box } from '@material-ui/core'
import { useForm } from '../../../../context/formContext'
import Swal from 'sweetalert2'
import { useHistory, useLocation } from 'react-router-dom'
import SaveIcon from '@material-ui/icons/Save'
import ExitIcon from '@material-ui/icons/ExitToApp'
import ReactTooltip from 'react-tooltip'
import DraftForm from '../../../../utils/formDraft'
import { useAuthentication } from '../../../../context/authenticationContext'
// import { updateForm } from '../../../../services/Forms/create'
import { createForm } from '../../../../services/IFI/create'
import ROUTES from '../../../../routers/routes'
import { validateEditForm } from '../../../../services/Forms/create'

const CreateEditForm = () => {
  const {
    userCompanyID,
    userFullName,
    userCompanyName,
    userCompanyType,
    userCountry,
    IdIFIToken,
    userIDB2C,
  } = useAuthentication()
  const history = useHistory()

  const {
    editForm,
    setIdEditForm,
    idEditForm,
    getEditFormByIFI,
    setPreEligibilityForm,
    step,
    setFetchRequest,
    preEligibilityForm,
    editLoading,
    questionsData,
    checkPYME,
    setCheckPYME,
  } = useForm()
  const location = useLocation()

  const cancelForm = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      confirmButtonColor: '#3085d6',
      denyButtonText: `No guardar`,
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (checkPYME) {
          const response = await validateEditForm(userIDB2C, 2, idEditForm)
          if (response.Success) {
            const exit = true
            saveForm(exit)
          }
        } else {
          alertSelectedPyme()
        }
      } else if (result.isDenied) {
        const response = await validateEditForm(userIDB2C, 2, idEditForm)
        if (response.Success) {
          setPreEligibilityForm([])
          history.push(ROUTES.IFIBORRADOR.pathname)
        }
      }
    })
  }

  const [loadingSave, setLoadingSave] = useState(false)

  const saveForm = (exit) => {
    setLoadingSave(true)

    const newArray = questionsData.filter((el) => {
      return el.Value !== null
    })

    setPreEligibilityForm({
      ...preEligibilityForm,
      answerActivityQuestion: newArray,
    })
    const objet = {
      ...preEligibilityForm,
      isInProtectedArea:
        preEligibilityForm.isInProtectedArea === ''
          ? null
          : preEligibilityForm.isInProtectedArea,
      answerActivityQuestion: newArray,
    }

    const draft = DraftForm(
      objet,
      preEligibilityForm.companyId &&
        userCompanyID !== preEligibilityForm.companyId
        ? preEligibilityForm.companyId
        : userCompanyID,
      userFullName,
      preEligibilityForm.companyName &&
        userCompanyName !== preEligibilityForm.companyName
        ? preEligibilityForm.companyName
        : userCompanyName,
      preEligibilityForm.companyTypeId &&
        userCompanyType !== preEligibilityForm.companyTypeId
        ? preEligibilityForm.companyTypeId
        : userCompanyType,
      userCountry,
      (preEligibilityForm.idIFI = IdIFIToken),
      (preEligibilityForm.idUserB2C = userIDB2C),
    )
    createForm(draft)
      .then((res) => {
        if (res.Code === 200) {
          setLoadingSave(false)
          const mensaje = `Formulario de Pre-Elegibilidad guardado exitosamente`
          Swal.fire({
            title: `Guardado`,
            text: `${mensaje}`,
            icon: 'success',
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Entendido',
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
          if (exit) {
            setPreEligibilityForm([])
            history.push(ROUTES.IFIBORRADOR.pathname)
          }
        }

        if (!res.Success) {
          setLoadingSave(false)
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ha ocurrido un error al intentar guardar el formulario',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Reintentar',
            footer:
              '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
        }
      })
      .catch((err) => {
        setLoadingSave(false)
        console.log(err)
      })
  }

  const alertSelectedPyme = () => {
    const mensaje =
      'Es necesario ingresar todos los datos de la sección Datos Generales para guardar el formulario '
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Campos sin completar ',
      text: mensaje,
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
    })
    setCheckPYME(false)
  }

  useEffect(() => {
    if (location.state !== undefined) {
      setIdEditForm(location.state)
    }
  }, [])

  useEffect(() => {
    if (
      idEditForm !== undefined &&
      idEditForm !== '' &&
      idEditForm > 0 &&
      idEditForm !== null
    ) {
      setFetchRequest(['create_form'])
    }
  }, [idEditForm])

  useEffect(() => {
    if (!editLoading) {
      setFetchRequest(['edit_page_ifi'])
    }
  }, [editLoading])

  useEffect(() => {
    if (!editForm.loading && editForm.list && !editLoading) {
      setPreEligibilityForm({
        ...preEligibilityForm,

        userFullName:
          editForm.list && editForm.list.UserFullName
            ? editForm.list.UserFullName
            : '',
        companyName:
          editForm.list &&
          editForm.list.MiPyme &&
          editForm.list.MiPyme.BusinessName
            ? editForm.list.MiPyme.BusinessName
            : '',
        companyTypeId:
          editForm.list &&
          editForm.list.MiPyme &&
          editForm.list.MiPyme.IdMiPymeType &&
          editForm.list.MiPyme.IdMiPymeType
            ? editForm.list.MiPyme.IdMiPymeType
            : '',
        companyId:
          editForm.list &&
          editForm.list.MiPyme &&
          editForm.list.MiPyme.TaxRegistration
            ? editForm.list.MiPyme.TaxRegistration
            : '',
        legalRepresentativeFullName:
          editForm.list && editForm.list.LegalRepresentativeName
            ? editForm.list.LegalRepresentativeName
            : '',
        legalRepresentativeIdentification:
          editForm.list && editForm.list.LegalRepresentativeIdentification
            ? editForm.list.LegalRepresentativeIdentification
            : '',
        subprojectName:
          editForm.list && editForm.list.Project.SubprojectName
            ? editForm.list.Project.SubprojectName
            : '',
        quantityEmployees:
          editForm.list && editForm.list.QuantityPermanentEmployees
            ? editForm.list.QuantityPermanentEmployees
            : '',
        idCurrency:
          editForm.list &&
          editForm.list.Currency &&
          editForm.list.Currency.IdCurrency
            ? editForm.list.Currency.IdCurrency
            : 0,
        requiredAmountSourceCurrency:
          editForm.list && editForm.list.RequiredAmountSourceCurrency
            ? editForm.list.RequiredAmountSourceCurrency
            : 0,
        requiredAmountDollarsCurrency:
          editForm.list && editForm.list.RequiredAmountDollarsCurrency
            ? editForm.list.RequiredAmountDollarsCurrency
            : 0,
        isInProtectedArea:
          editForm.list && editForm.list.IsInProtectedArea !== null
            ? editForm.list.IsInProtectedArea
            : '',
        protectedAreaLocation:
          editForm.list && editForm.list.ProtectedAreaLocation
            ? editForm.list.ProtectedAreaLocation
            : '',
        affectsCulturalHeritage:
          editForm.list && editForm.list.AffectsCulturalHeritage !== null
            ? editForm.list.AffectsCulturalHeritage
            : '',
        detailAffectsCulturalHeritage:
          editForm.list && editForm.list.DetailAffectsCulturalHeritage
            ? editForm.list.DetailAffectsCulturalHeritage
            : '',

        answerActivityQuestion:
          editForm.list && editForm.list.AnnexAnswer
            ? editForm.list.AnnexAnswer
            : [],

        idClimateThreat:
          editForm.list &&
          editForm.list.ClimateThreat &&
          editForm.list.ClimateThreat.IdClimateThreat
            ? editForm.list.ClimateThreat.IdClimateThreat
            : '',
        idSector:
          editForm.list && editForm.list.Sector && editForm.list.Sector.IdSector
            ? editForm.list.Sector.IdSector
            : '',
        idSectorActivity:
          editForm.list &&
          editForm.list.Activity &&
          editForm.list.Activity.IdActivity
            ? editForm.list.Activity.IdActivity
            : null,
        detailSector:
          editForm.list && editForm.list.DetailSector
            ? editForm.list.DetailSector
            : '',
        detailActivity:
          editForm.list && editForm.list.DetailActivity
            ? editForm.list.DetailActivity
            : '',

        detailClimateThreat:
          editForm.list && editForm.list.DetailClimateThreat
            ? editForm.list.DetailClimateThreat
            : '',

        idBusinessLine:
          editForm.list &&
          editForm.list.BusinessLine &&
          editForm.list.BusinessLine.IdBusinessLine
            ? editForm.list.BusinessLine.IdBusinessLine
            : '',
        detailAdaptationAction:
          editForm.list && editForm.list.DetailAdaptationActions
            ? editForm.list.DetailAdaptationActions
            : '',
        idAdaptationAction:
          editForm.list &&
          editForm.list.AdaptationActions &&
          editForm.list.AdaptationActions.IdAdaptationAction
            ? editForm.list.AdaptationActions.IdAdaptationAction
            : '',
        idDepartment:
          editForm.list && editForm.list.Project.IdDepartment
            ? editForm.list.Project.IdDepartment
            : '',
        idMunicipality:
          editForm.list && editForm.list.Project.IdMunicipality
            ? editForm.list.Project.IdMunicipality
            : '',
        companyPhone:
          editForm.list && editForm.list.Project.Phone
            ? editForm.list.Project.Phone
            : '',
        companyAddress:
          editForm.list && editForm.list.Project.Address
            ? editForm.list.Project.Address
            : '',
        negativeImpact:
          editForm.list && editForm.list.NegativeImpact
            ? editForm.list.NegativeImpact.split('|')
            : [],
        detailBusinessLine: '',
        idForm: idEditForm,
      })
    }
  }, [editForm.list, editLoading, editForm.loading])

  useEffect(() => {
    getEditFormByIFI()
  }, [])
  return (
    <>
      {!editForm.loading && !editLoading && editForm.list !== '' ? (
        <div
          id="wizard-form"
          style={{
            overflow: 'hidden',
            backgroundColor: 'white',
            boxShadow: '0px 0px 12px -2px rgba(0,0,0,0.39)',
          }}
        >
          <div style={{ marginBottom: '48px' }}>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={1}
              style={{ marginTop: '18px', marginBottom: '16px' }}
            >
              <Grid item md={12} sm={12} xs={12}>
                <div
                  style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    marginBottom: '8px',
                  }}
                >
                  <label className="formTitle">
                    Formulario Pre-elegibilidad de Inversiones para
                    Financiamiento
                  </label>
                </div>
                <label className="formDescription">
                  Rellene la información requerida para registrar el formulario
                </label>
              </Grid>
            </Grid>
            <Grid
              container
              md={12}
              sm={12}
              spacing={1}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              <Grid item>
                <div
                  data-tip
                  data-for="exitPop"
                  onClick={() => cancelForm()}
                  style={{
                    backgroundColor: 'red',
                    color: '#fff',
                    width: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    padding: '5px',
                    cursor: 'pointer',
                  }}
                >
                  <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                  <ReactTooltip
                    id="exitPop"
                    effect="solid"
                    backgroundColor="red"
                  >
                    <span>Regresar</span>
                  </ReactTooltip>
                </div>
              </Grid>
              {!loadingSave ? (
                <Grid item>
                  <div
                    onClick={() =>
                      checkPYME ? saveForm() : alertSelectedPyme()
                    }
                    data-tip
                    data-for="savePop"
                    style={{
                      backgroundColor: checkPYME ? '#5cb85c' : 'gray',

                      color: '#fff',
                      width: '40px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '4px',
                      padding: '5px',
                      cursor: 'pointer',
                    }}
                  >
                    <SaveIcon />
                  </div>
                  <ReactTooltip
                    id="savePop"
                    effect="solid"
                    backgroundColor="#5cb85c"
                  >
                    <span>Guardar Borrador</span>
                  </ReactTooltip>
                </Grid>
              ) : (
                <Grid item>
                  <div
                    data-tip
                    data-for="savePop"
                    style={{
                      backgroundColor: 'gray',
                      color: '#fff',
                      width: '40px',
                      height: '24px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '4px',
                      padding: '5px',
                    }}
                  >
                    <Box sx={{ display: 'flex' }}>
                      <CircularProgress
                        style={{ color: '#fff', height: '18px', width: '18px' }}
                      />
                    </Box>
                  </div>
                  <ReactTooltip
                    id="savePop"
                    effect="solid"
                    backgroundColor="#5cb85c"
                  >
                    <span>Guardar Borrador</span>
                  </ReactTooltip>
                </Grid>
              )}
            </Grid>
          </div>
          <Grid
            container
            spacing={1}
            style={{ marginTop: '18px', marginBottom: '36px' }}
          >
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              className={`${
                step === 1 ? `stepper__title-active` : `stepper__title-inactive`
              }`}
            >
              <label>Datos Generales</label>
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              className={`${
                step === 2 ? `stepper__title-active` : `stepper__title-inactive`
              }`}
            >
              <label>Datos de Ubicación</label>
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              className={`${
                step === 3 ? `stepper__title-active` : `stepper__title-inactive`
              }`}
            >
              <label>Datos de Evaluación</label>
            </Grid>
          </Grid>

          <StepWizard initialStep={1}>
            <GeneralData />
            <LocationData />
            <EvaluationData />
          </StepWizard>
        </div>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}
    </>
  )
}

export default CreateEditForm
